import type { AdminCrewReportRunningVesselReportActionProps } from "../../models/admin-crew-report.models";
import type { KeyboardEvent, MouseEvent } from "react";

const AdminCrewReportRunningVesselReportAction = ({
  vessel,
  activeRequestImoNumber,
  reportActionsDisabled,
  requestActionsDisabled,
  requestActionBusy,
  onShowReport,
  onRequestReport,
}: AdminCrewReportRunningVesselReportActionProps) => {
  const isRequestAction = !vessel.hasCrewReport;
  const isActiveRequest = activeRequestImoNumber === vessel.imoNumber;
  const isBusy = isRequestAction && isActiveRequest && requestActionBusy;
  const isRequestDisabled = isRequestAction && requestActionsDisabled;
  const isReportActionDisabled = isRequestDisabled || (reportActionsDisabled && !isActiveRequest);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (reportActionsDisabled || isRequestDisabled) return;

    if (isRequestAction) onRequestReport(vessel);
    else onShowReport(vessel);
  };
  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "Enter" || event.key === " ") event.stopPropagation();
  };

  return (
    <button
      type="button"
      className="font-normal text-[#005474] hover:text-green disabled:cursor-not-allowed disabled:opacity-50 dark:text-teal-300"
      aria-label={`${isRequestAction ? "Request" : "Show"} Crew Report for ${vessel.vesselName || vessel.imoNumber}`}
      aria-busy={isBusy || undefined}
      aria-disabled={(reportActionsDisabled && isActiveRequest) || undefined}
      disabled={isReportActionDisabled}
      data-test={`admin-crew-report-${isRequestAction ? "request" : "show"}-report-${vessel.imoNumber}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {isRequestAction ? "Request Report" : "Show Report"}
    </button>
  );
};

export default AdminCrewReportRunningVesselReportAction;
